import PropTypes from "prop-types";
import React from "react";
import BenefitPanel from "./BenefitPanel";
import { benefitsErrorHandler } from "cxa-utils";
import Button from "cxa-components/button";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import messages from "components/messagesDescription";
import { renderVideoOnNewWindow } from "utils/html";

const BenefitList = injectIntl(props => {
  const {
    benefits,
    benefitsMap,
    saving,
    saveError,
    enrolmentData,
    selectDefault,
    saveEnrolmentSelection,
    onChangePerMemberSelection,
    helpSettings,
    showPopup,
    intl,
  } = props;
  const defaultSelectionNots = `<b>${intl.formatMessage(
    messages.notesDescription
  )}</b>${intl.formatMessage(messages.selectionNotesDescription)}`;
  const selectionNotes = enrolmentData.selectionNotes
    ? enrolmentData.selectionNotes.value
    : defaultSelectionNots;
  const currency = enrolmentData.clientSettings
    ? enrolmentData.clientSettings.enrolmentCurrency
    : {};

  let saveErrorText;

  if (saveError) {
    const applyErrorHandler = benefitsErrorHandler(intl);
    const { messageKey, message, extra } = saveError;
    const extraValue = Array.isArray(extra)
      ? extra.map(val => benefitsMap[val] || val) // it can be contained 1 or more values
      : benefitsMap[extra];

    saveErrorText = applyErrorHandler({
      message: message || messageKey,
      extraValue: extraValue || extra,
      messageKey,
    });
  }

  const benefitPanels = benefits.map((benefit, index) => {
    if (benefit.selectable) {
      return (
        <BenefitPanel
          key={index}
          benefit={benefit}
          currency={currency}
          onChangePerMemberSelection={onChangePerMemberSelection}
        />
      );
    }
  });

  const videos = (helpSettings.items || []).filter(item => item.title === "Enrolment") || [];
  const showHelpVideo = () => {
    renderVideoOnNewWindow(videos[0].url);
  };
  return (
    <form className="cxa-c-form">
      <Button primary type="button" className="u-margin-bottom" onClick={selectDefault}>
        <FormattedHTMLMessage {...messages.selectDefaultDescription} />
      </Button>
      {videos.length > 0 && videos[0].url && (
        <Button
          primary
          type="button"
          className="u-margin-bottom"
          onClick={showHelpVideo}
          style={{ height: "60px" }}
        >
          {intl.formatMessage(messages.watchTutorialText)}
        </Button>
      )}
      {benefitPanels}
      {selectionNotes && (
        <p
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({
              id: selectionNotes,
              defaultMessage: selectionNotes,
            }),
          }}
        />
      )}

      {saveErrorText && !saving ? <p className="error"> {saveErrorText} </p> : null}
      <Button primary type="button" submitting={saving} onClick={saveEnrolmentSelection}>
        {intl.formatMessage(messages.continueDescription)}
      </Button>
    </form>
  );
});

BenefitList.propTypes = {
  benefits: PropTypes.array,
  benefitsMap: PropTypes.object,
  saving: PropTypes.bool,
  saveError: PropTypes.object,
  enrolmentData: PropTypes.object,
  selectDefault: PropTypes.func,
  saveEnrolmentSelection: PropTypes.func,
  onChangePerMemberSelection: PropTypes.func,
};

export default BenefitList;



// WEBPACK FOOTER //
// ./components/employee/shop/BenefitList.js